import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class PagosApiService {

  apiURL: string = config.API_DATA_URL + '/pagos';
  data: any[] = [];

  constructor(public http: HttpClient) { }

  ////////////////////////////////////
  //// DETALLE FACTURA PROVEEDOR  ////
  ////////////////////////////////////
  public GetFacturasProveedor(idProveedor: number, idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturasProveedor/' + idProveedor + '/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  ////////////////////////////////////
  //// DETALLE FACTURA PROVEEDOR  ////
  ////////////////////////////////////
  public GetFacturasXProveedor(idProveedor: number, idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturasXProveedor/' + idProveedor + '/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetOrdenesXProveedor(idProveedor: number, idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetOrdenesXProveedor/' + idProveedor + '/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public PagarFacturasProveedor(facturasCollection: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(facturasCollection);
    return this.http.post(this.apiURL + '/PagarFacturasProveedor', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public GetFacturasXOrdenServicio(idProveedor: number, idOrdenServicio: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturasXOrdenServicio/' + idProveedor + '/' + idOrdenServicio, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetFacturasPenditeFoto(idProveedor: number, idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturasPendienteFoto/' + idProveedor + '/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetFacturasCargoInterno(idProveedor: number, idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturasCargoInterno/' + idProveedor + '/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetProveedor(idProveedor: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetProveedor/' + idProveedor, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetFacturaProveedor(idFacturaProveedor: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturaProveedor/' + idFacturaProveedor, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetCuentasProveedor(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetCuentasProveedor/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public PagarFactura(pagarFactura: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(pagarFactura);
    return this.http.post(this.apiURL + '/PagarFactura', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ComprobantePago(comprobante: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(comprobante);
    return this.http.post(this.apiURL + '/ComprobantePago', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public GetFacturasPagadas(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturasPagadas/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/pagos-api.service.ts